(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  
document.addEventListener("DOMContentLoaded", () => {
  const questions = document.querySelectorAll(".faqs-question");

  questions.forEach((question) => {
    question.addEventListener("click", () => {
      // Close all other FAQs
      questions.forEach((item) => {
        if (item !== question) {
          item.classList.remove("active");
          const answer = item.nextElementSibling;
          if (answer) {
            answer.style.height = "0px";
          }
        }
      });

      // Toggle the clicked FAQ
      const answer = question.nextElementSibling;
      if (question.classList.contains("active")) {
        // If already open, close it
        question.classList.remove("active");
        if (answer) {
          answer.style.height = "0px";
        }
      } else {
        // If closed, open it
        question.classList.add("active");
        if (answer) {
          answer.style.height = answer.scrollHeight + "px";
        }
      }
    });
  });

  // Set the first FAQ open by default
  const firstAnswer = document.querySelector(".faqs-answer.active");
  if (firstAnswer) {
    firstAnswer.style.height = firstAnswer.scrollHeight + "px";
  }
});


  } catch(e) { console.error(e); }
})();
})();
